import { useQueryParams } from '@solinkcorp/utils/hooks';

import { SDM_THEME_QUERY_PARAM, SDM_THEME_QUERY_VALUE_DARK } from '../../constants';

const DARK_MODE_CLASS = 'dark';

/**
 * Keeps `document.body` `dark` class in sync with `?theme=dark` for Tailwind `darkMode: 'class'`.
 * Applies during render so children that read `body` on first paint (e.g. `useDarkMode`) stay aligned.
 */
export function useDarkModeSync() {
  const isDark = useDarkMode();

  if (typeof document !== 'undefined') {
    document.body.classList.toggle(DARK_MODE_CLASS, isDark);
  }
}

export const useDarkMode = (): boolean => {
  const [query] = useQueryParams();
  const isDark = query.get(SDM_THEME_QUERY_PARAM) === SDM_THEME_QUERY_VALUE_DARK;

  return isDark;
};
